module.exports = new __parcel__URL__("noData.8500689b.svg").toString();